import { Box, Card, CardContent, Grid, Paper, Stack, ToggleButton, Typography } from "@mui/material";

import ToggleButtonGroup, { toggleButtonGroupClasses } from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";

import PlansCard from "./PlansCard";
import { useTranslation } from "react-i18next";
import HeaderBar from "../HeaderBar";

import LightTooltip from "../../ui/LightTooltip";

import InfoIcon from "@mui/icons-material/Info";

import plansInfo from "../../Js/plans";
import FormDialog from "../../ui/FormDialog";
import CancelPlanForm from "../CancelPlanForm";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AlertDialog from "../../ui/AlertDialog";

import subscriptionService from "../../../services/subscription";
import moment from "moment/moment";
import { isCustomPlan } from "../../../utils/utils";
import { useTheme } from "@mui/material/styles";
import BaseButton from "../../ui/BaseButton";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0.5),
        border: 0,
        borderRadius: 6,
    },
    [`& .${toggleButtonGroupClasses.firstButton},& .${toggleButtonGroupClasses.lastButton}`]: {
        width: 120,
    },
}));

const PlanSubs = (props) => {
    const {
        setTitleModal,
        setOpenAlert,
        setAgreeBtnMsg,
        setDisagreeBtnMsg,
        setBodyMess,
        setCurrentPlan,
        paymentType,
        setPaymentType,
        setCurrentLevel,
        setPriceMonthly,
        setPriceMonthlyOG,
        origin,
        activePlan,
        currentPlan,
        setIsLoading,
        setShowCart,
        companyDetails,
        handleShowCart,
        maxFreeCompanies,
        currentFreeCompanies,
        setShow,
        setAlertType,
        setMessage,
        isCancelled = false,
    } = props;

    const [t] = useTranslation("global");

    const todos = useSelector((state) => state.value);
    const [isDowngrade, setIsDowngrade] = useState(companyDetails?.subscription?.last_change ? true : false);
    const [isCancel, setIsCancel] = useState(companyDetails?.subscription?.last_cancel ? true : false);

    const [openAlertCancel, setOpenAlertCancel] = useState(false);
    const [reasons, setReasons] = useState(null);
    const [details, setDetails] = useState("");
    const [isError, setIsError] = useState(false);
    const [downgradePlanInfo, setDowngradePlanInfo] = useState({});
    const [openAlertReactivate, setOpenAlertReactivate] = useState(false);
    const theme = useTheme(); // Obtener el tema actual

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null) {
            if (companyDetails?.last_invoice?.line_items[0]?.line_qty === 365) {
                // Si la compra anterior fue anual, solo puede hacer upgrade de manera anual también
                setPaymentType("annual");
            } else {
                setPaymentType(newAlignment);
            }
        }
    };

    useEffect(() => {
        (async () => {
            if (isDowngrade) {
                await subscriptionService
                    .getHistorySubsDetails({
                        history_id: companyDetails?.subscription?.last_change,
                    })
                    .then((response) => {
                        let plan = plansInfo.find((plan) =>
                            plan.levels.some((level) => level.id === response?.changed_plan)
                        );

                        plan.selectLevel = response?.changed_plan;

                        setDowngradePlanInfo(plan);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            if (isCancel) {
                let plan = plansInfo.find((plan) =>
                    plan.levels.some((level) => level.id === companyDetails?.subscription?.subscription_plan)
                );

                plan.selectLevel = companyDetails?.subscription?.subscription_plan;

                setDowngradePlanInfo(plan);
            }
        })();
    }, [isDowngrade, companyDetails, isCancel]);

    const handleCloseDialog = () => {
        setOpenAlert(false);
        setOpenAlertCancel(false);
        setReasons(null);
        setDetails("");
        setIsError(false);
    };

    const handleCloseDialogReactivate = () => {
        setOpenAlertReactivate(false);
    };

    const cancelPlan = async () => {
        if (!reasons) {
            setIsError(true);
        } else {
            if (reasons === "6" && details.trim() === "") {
                setIsError(true);
            } else {
                const newVAl = {
                    subscription_plan: activePlan,
                    line_type: 7,
                    line_amount: 0.0,
                    line_unit_amount: 0.0,
                    line_qty: 1,
                    line_since_date: moment().format(),
                    line_end_date: moment().add(1, "M").format(),
                };

                const params = {
                    company_id: todos.companyID,
                    cart_lines: [newVAl],
                };

                setCurrentPlan({
                    value: activePlan,
                    custom: isCustomPlan(companyDetails.subscription.subscription_plan),
                    type: "cancel",
                    endDate: companyDetails.subscription.end_date,
                });

                setPriceMonthlyOG(0);
                setCurrentLevel(activePlan);

                setIsLoading(true);

                await subscriptionService
                    .updateCart(params)
                    .then()
                    .catch((error) => {
                        console.log(error);
                    });

                setIsLoading(false);

                setShowCart(true);
            }
        }
    };

    const handleOpenModal = () => {
        setOpenAlertCancel(true);
    };

    const planFeatures = [t("plans.customFormat"), t("plans.userProfile"), t("plans.unlimitedStorage")];

    const iconStyles = { color: "#361A52", ml: 0.5, mb: "-2px" };

    const cancelPlanButtons = (
        <Grid container justifyContent="space-between" sx={{ width: 600 }}>
            <Grid item>
                <BaseButton variantType="primaryTextButton" onClick={handleCloseDialog} sizebutton="m">
                    {t("team.cancel")}
                </BaseButton>
            </Grid>
            <Grid item>
                <BaseButton onClick={cancelPlan} sizebutton="m">
                    {t("subscription.confirm")}
                </BaseButton>
            </Grid>
        </Grid>
    );

    const confirmReactivate = async () => {
        setIsLoading(true);

        let params = {
            subscription_id: companyDetails.subscription._id,
        };

        await subscriptionService
            .reactivateSubscriptionChanged(params)
            .then(async () => {
                setShow(true);
                setAlertType("success");
                setMessage(t("subscription.downgradePlanSucess"));

                const params = {
                    franchise_id: todos.franchiseID,
                    company_id: todos.companyID,
                    cart_lines: [],
                };

                await subscriptionService
                    .updateCart(params)
                    .then()
                    .catch((error) => {
                        console.log(error);
                    });

                setShowCart(false);
                handleCloseDialogReactivate();
                setIsDowngrade(false);
            })
            .catch((error) => {
                console.log(error);
                setMessage("Error");
                setAlertType("error");
            });

        setIsLoading(false);
    };

    const handleClickReactivatePlan = async () => {
        setIsLoading(true);

        let params = {
            subscription_id: companyDetails.subscription._id,
        };

        await subscriptionService
            .reactivateSubscription(params)
            .then(async () => {
                setShow(true);
                setAlertType("success");
                setMessage(t("subscription.downgradePlanSucess"));

                const params = {
                    franchise_id: todos.franchiseID,
                    company_id: todos.companyID,
                    cart_lines: [],
                };

                await subscriptionService
                    .updateCart(params)
                    .then()
                    .catch((error) => {
                        console.log(error);
                    });

                setShowCart(false);
                handleCloseDialogReactivate();
                setIsCancel(false);
            })
            .catch((error) => {
                console.log(error);
                setMessage("Error");
                setAlertType("error");
            });

        setIsLoading(false);
    };

    const bodyMess = (
        <Grid container justifyContent="center" spacing={2}>
            <Grid item>
                <Typography fontSize={14} textAlign="justify">
                    {t("subscription.reactivatePlanChanged")} {t("subscription.reactivatePlanChanged2")}
                </Typography>
            </Grid>
            <Grid item>
                <Typography fontSize={14} textAlign="justify">
                    {t("dialog.warningConfirm2")}
                </Typography>
            </Grid>
        </Grid>
    );

    return (
        <>
            <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                {origin === "updateSubscription" && (
                    <Grid item xs={12}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography variant="h2">
                                {`${t("plans.compPlans")} ${
                                    companyDetails.company_name ?? companyDetails.franchise_name
                                }`}
                            </Typography>
                        </Stack>
                    </Grid>
                )}
                {(isDowngrade || isCancel) && (
                    <HeaderBar
                        plansInfo={plansInfo}
                        currentPlan={activePlan}
                        currentPlanInfo={downgradePlanInfo}
                        setOpenAlert={setOpenAlert}
                        lastChange={isDowngrade ? true : false}
                        wasCancel={isCancel ? true : false}
                        setOpenAlertReactivate={setOpenAlertReactivate}
                    />
                )}
                <Grid item xs={12}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Box>
                            {origin === "register" && (
                                <Typography variant="h2" ml={1.5}>
                                    {t("plans.choosePlanFirm")}
                                </Typography>
                            )}
                        </Box>
                        <Paper
                            elevation={0}
                            sx={{
                                display: "flex",
                                border: `1px solid #9470EE`,
                                flexWrap: "wrap",
                                borderRadius: 2,
                            }}
                        >
                            <StyledToggleButtonGroup
                                value={paymentType}
                                exclusive
                                onChange={handleAlignment}
                                aria-label="paymentType"
                                sx={{ height: 45 }}
                            >
                                <ToggleButton
                                    value="monthly"
                                    aria-label="monthly"
                                    sx={{
                                        backgroundColor: paymentType === "monthly" ? "#9470EE !important" : "white",
                                        color: paymentType === "monthly" ? "white !important" : "initial",
                                        "&:hover": {
                                            backgroundColor:
                                                paymentType === "monthly" ? "#8564D6 !important" : "lightgray",
                                        },
                                    }}
                                >
                                    {t("navBar.monthly")}
                                </ToggleButton>
                                <ToggleButton
                                    value="annual"
                                    aria-label="annual"
                                    sx={{
                                        backgroundColor: paymentType === "annual" ? "#9470EE !important" : "white",
                                        color: paymentType === "annual" ? "white !important" : "initial",
                                        "&:hover": {
                                            backgroundColor:
                                                paymentType === "annual" ? "#8564D6 !important" : "lightgray",
                                        },
                                    }}
                                >
                                    {t("navBar.annual")}
                                </ToggleButton>
                            </StyledToggleButtonGroup>
                        </Paper>
                    </Stack>
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12} md>
                    <Card sx={{ boxShadow: "none", bgcolor: "transparent" }}>
                        <CardContent sx={{ textAlign: { xs: "center", md: "left" } }}>
                            <Typography variant="h3">{t("plans.allPlansInc")}</Typography>
                            <Box
                                sx={{
                                    textAlign: { xs: "center", md: "left" },
                                    display: { xs: "flex", md: "block" },
                                    justifyContent: { xs: "center", md: "start" },
                                }}
                            >
                                <ul style={{ marginBottom: 0 }}>
                                    {planFeatures.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </Box>

                            <Typography variant="h3" gutterBottom mt={7.5}>
                                {t("plans.docConv")}
                            </Typography>
                            <Typography gutterBottom>
                                {t("converter.checks")}
                                <LightTooltip title={t("plans.checksTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.factRec")}
                                <LightTooltip title={t("plans.invTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("dashboard.transactions")}
                                <LightTooltip title={t("plans.eeccTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography variant="h3" gutterBottom mt={2}>
                                {t("plans.customerSupp")}
                            </Typography>
                            <Typography gutterBottom>
                                Onboarding
                                <LightTooltip title={t("plans.onboardingTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.support")}
                                <LightTooltip title={t("plans.trainingTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.people")}
                                <LightTooltip title={t("plans.peopleTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography variant="h3" gutterBottom mt={2}>
                                {t("plans.addFeatures")}
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.panelMonit")}
                                <LightTooltip title={t("plans.monitoringTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.productUpd")}
                                <LightTooltip title={t("plans.productTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                            <Typography gutterBottom>
                                {t("plans.exten")}
                                <LightTooltip title={t("plans.rollOverTooltip")}>
                                    <InfoIcon fontSize="inherit" sx={iconStyles} />
                                </LightTooltip>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {plansInfo.map((item) => (
                    <Grid item xs={12} md={3.2} key={item.planId}>
                        <PlansCard
                            plan={item}
                            levels={item.levels}
                            paymentType={paymentType}
                            setTitleModal={setTitleModal}
                            setOpenAlert={setOpenAlert}
                            setAgreeBtnMsg={setAgreeBtnMsg}
                            setDisagreeBtnMsg={setDisagreeBtnMsg}
                            setBodyMess={setBodyMess}
                            setCurrentPlan={setCurrentPlan}
                            setLevelGlobal={setCurrentLevel}
                            setPriceMonthlyGlobal={setPriceMonthly}
                            setPriceMonthlyOG={setPriceMonthlyOG}
                            origin={origin}
                            activePlan={activePlan}
                            currentPlan={currentPlan}
                            handleShowCart={handleShowCart}
                            maxFreeCompanies={maxFreeCompanies}
                            currentFreeCompanies={currentFreeCompanies}
                            handleOpenModal={handleOpenModal}
                            isCancelled={isCancelled}
                        />
                    </Grid>
                ))}
            </Grid>
            <FormDialog
                open={openAlertCancel}
                handleClose={handleCloseDialog}
                maxWidth="md"
                title={
                    <>
                        <Typography component="span" variant="h3" sx={{ color: theme.palette.secondary.main }}>
                            {todos?.userInfo?.user_name ?? ""}
                        </Typography>
                        ,{" "}
                        <Typography component="span" variant="h3">
                            {t("plans.regretDes")}
                        </Typography>
                    </>
                }
                content={
                    <CancelPlanForm
                        reasons={reasons}
                        setReasons={setReasons}
                        details={details}
                        setDetails={setDetails}
                        isError={isError}
                        currentPlanInfo={companyDetails}
                    />
                }
                actions={cancelPlanButtons}
                custom={true}
            />
            <AlertDialog
                open={openAlertReactivate}
                onClose={handleCloseDialogReactivate}
                agreeBtnLabel={t("dialog.continue")}
                disagreeBtnLabel={t("dialog.cancel")}
                type={"warning"}
                title={t("dialog.warning")}
                message={bodyMess}
                agreeAction={isCancel ? handleClickReactivatePlan : confirmReactivate}
                maxWidth="sm"
            />
        </>
    );
};

export default PlanSubs;
